import React from 'react';
import ContainerComponent from '../../helpers/components/container.component';
import HomeLayout from './components/home_layout';

const HomeIndex = () => {
    return (
        <>
            <ContainerComponent span={22} top={20}>
                <HomeLayout />
            </ContainerComponent>
        </>
    );
}

export default HomeIndex;